const apiVersion = 'v1';
const hostname = window && window.location && window.location.hostname;
const env =
  hostname === 'localhost'
    ? 'development'
    : hostname.indexOf('freshstatus.io') > -1
    ? 'production'
    : 'staging';

const production = {
  APP: 'freshstatus',
  ENV: 'production',
  OB_ROLE: 'admin',
  HOST: 'https://api.freshstatus.io',
  PUBLIC_API_HOST: 'https://public-api.freshstatus.io',
  CDN_URL: 'https://cdn.freshstatus.io',
  PUBLIC_API_URL: 'https://public-api.freshstatus.io/v1/public',
  ALERTS_WHITELIST: [],
  ALERTS: false,
  clientId: '208568830335492804',
  signupUrl: 'https://www.freshworks.com/statuspage/login',
  FRESH_DESK_INTEGRATION: true,
  FRESH_SERVICE_INTEGRATION: true,
  WEBHOOK_INTEGRATION: true,
  FRESH_PING_INTEGRATION: true
};

const staging = {
  APP: 'freshstatus',
  ENV: 'staging',
  OB_ROLE: 'admin',
  HOST: 'https://api.freshstatus-sta91ng.io',
  PUBLIC_API_HOST: 'https://public-api.freshstatus.io',
  CDN_URL: 'https://cdn.freshstatus-sta91ng.io',
  PUBLIC_API_URL: 'https://public-api.freshstatus-sta91ng.io/v1/public',
  ALERTS_WHITELIST: [82, 41, 112, 2, 24, 1195, 19],
  ALERTS: false,
  clientId: '315470071583498033',
  signupUrl: 'https://staging-fw.freshworks.com/statuspage/login',
  HEAP: '751400537',
  FRESH_DESK_INTEGRATION: true,
  FRESH_SERVICE_INTEGRATION: true,
  WEBHOOK_INTEGRATION: true,
  FRESH_PING_INTEGRATION: true
};

const development = {
  APP: 'freshstatus',
  ENV: 'staging',
  // HOST: 'http://localhost:8000',
  HOST: 'https://api.freshstatus-sta91ng.io',
  PUBLIC_API_HOST: 'https://public-api.freshstatus.io',
  CDN_URL: 'https://cdn.freshstatus-sta91ng.io',
  PUBLIC_API_URL: 'https://public-api.freshstatus-sta91ng.io/v1/public',
  OB_ROLE: 'admin',
  ALERTS_WHITELIST: [82, 112, 181, 2, 24, 1195, 19],
  ALERTS: false,
  signupUrl: 'https://staging-fw.freshworks.com/statuspage/login',
  FRESH_DESK_INTEGRATION: true,
  FRESH_SERVICE_INTEGRATION: true,
  WEBHOOK_INTEGRATION: true,
  FRESH_PING_INTEGRATION: true
};

const config = {
  development,
  staging,
  production
};

export default config[env];

export const API_ROOT = `${config[env].HOST}/${apiVersion}`;
export const PUBLIC_API_ROOT = `${config[env].PUBLIC_API_HOST}/${apiVersion}`;
export const SIGN_UP_URL = `${config[env].signupUrl}`;

export const apiStatuses = {
  IDLE: 0,
  LOADING: 1,
  SUCCESS: 2,
  ERROR: 3
};

export const getAPIURL = resourceURL =>
  `${config[env].HOST}/${apiVersion}${resourceURL}`;
